import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "side-panel-title" }
const _hoisted_2 = { class: "side-panel-content" }

import { ref } from "vue";

import Card from "primevue/card";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideMenuPanel',
  props: [
    "icon",
    "label",
    "noOverflow",
],
  emits: [
],
  setup(__props, { emit: __emit }) {

const extraClasses = ref<string[]>([]);

const props = __props;

if (props.noOverflow) {
    extraClasses.value.push('no-overflow')
}

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["side-panel", extraClasses.value])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})